import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/official/home/index.vue'
import Model from '@/views/official/model/index.vue'
import Pricing from '@/views/official/pricing/index.vue'
import Solutions from '@/views/official/solutions/index.vue'
import Products from '@/views/official/products/index.vue'
import Docs from '@/views/official/docs/index.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的位置（浏览器前进/后退），则恢复到该位置
    if (savedPosition) {
      return savedPosition
    }
    // 如果URL包含锚点，滚动到指定元素
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth',
        offset: { x: 0, y: 0 } // 补偿固定头部高度和额外空间
      }
    }
    // 否则滚动到页面顶部
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: '主页',
      component: Home
    },
    {
      path: '/model',
      name: '模型',
      component: Model
    },
    {
      path: '/pricing',
      name: '定价',
      component: Pricing
    },
    {
      path: '/solutions',
      name: '解决方案',
      component: Solutions
    },
    {
      path: '/products',
      name: '产品',
      component: Products
    },
    {
      path: '/docs',
      name: '文档',
      component: Docs
    }
  ]
})

